/**
 * 思维链问答Mixin
 */
export default {
    methods: {
        /**
        * 带思维链的回答
        */
        thinkAsk (ask) {
            let { input, type, content } = ask;

            if (ask.type === 'start') {
                this.ui.typing = true;
                this.addAsk(input, null, Date.now());
                this.currentChat.messages.push({ role: 'think', content: '' });
            } else if (ask.type === '[done]') {
                this.thinkSocketFinish({ think: '', content: ask.answer });
            } else {
                this.$nextTick(() => {
                    this.$refs[`msg${this.currentChat.messages.length - 1}`][0].addAsk(content);
                });
            }
        },

        /**
        * 带思维链的回答完成
        */
        thinkSocketFinish (data) {
            let last = this.currentChat.messages[this.currentChat.messages.length - 1];
            last.content = data.content;
            last.think = data.think;

            this.$set(last, 'finished', true);
            this.ui.typing = false;

            // 保存上下文
            this.saveContext();
        }
    }
};
